"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = require("@emotion/react");

var _theme = require("@zip/theme");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgWarningUnsuccessful = function SvgWarningUnsuccessful(_ref) {
  var props = _extends({}, _ref);

  var theme = (0, _react.useTheme)();

  switch (theme.name) {
    case _theme.fearlessBusiness.name:
      return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
        viewBox: "0 0 110 100",
        fill: "none"
      }, props), {}, {
        children: [(0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M98.162 54.787a8.238 8.238 0 00-7.482-2.245c-.83-7.655-7.31-13.616-15.186-13.616-1.505 0-2.955.228-4.327.632-3.413-6.612-10.295-11.143-18.25-11.143-9.149 0-16.892 5.987-19.549 14.255-.84-.165-1.71-.255-2.6-.255-7.477 0-13.538 6.06-13.538 13.537 0 7.476 6.061 13.537 13.538 13.537l42.146-.218a10.824 10.824 0 01-1.152-4.853c0-6.02 4.879-10.898 10.9-10.898 6.018 0 10.897 4.879 10.897 10.898 0 1.697-.399 3.297-1.089 4.727 2.395-.108 4.797-.593 6.47-2.346 3.148-3.297 2.445-8.789-.778-12.012zM11.349 66.939H4.336a1.612 1.612 0 110-3.226h7.013c.892 0 1.612.72 1.612 1.613 0 .892-.72 1.613-1.612 1.613zM68.57 99.636h-7.012a1.612 1.612 0 110-3.226h7.012c.892 0 1.613.721 1.613 1.613s-.72 1.613-1.613 1.613z",
          fill: "#D0EEFD"
        }), (0, _jsxRuntime.jsx)("mask", {
          id: "error_svg__a",
          maskUnits: "userSpaceOnUse",
          x: 0,
          y: 69,
          width: 11,
          height: 4,
          children: (0, _jsxRuntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 69.161h10.237v3.226H0V69.16z",
            fill: "#fff"
          })
        }), (0, _jsxRuntime.jsx)("g", {
          mask: "url(#error_svg__a)",
          children: (0, _jsxRuntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.624 72.387H1.612a1.612 1.612 0 110-3.226h7.012c.892 0 1.613.721 1.613 1.613s-.721 1.613-1.613 1.613z",
            fill: "#D0EEFD"
          })
        }), (0, _jsxRuntime.jsx)("mask", {
          id: "error_svg__b",
          maskUnits: "userSpaceOnUse",
          x: 96,
          y: 1,
          width: 13,
          height: 13,
          children: (0, _jsxRuntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M96.474 1.614h11.8v11.798h-11.8V1.614z",
            fill: "#fff"
          })
        }), (0, _jsxRuntime.jsx)("g", {
          mask: "url(#error_svg__b)",
          children: (0, _jsxRuntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M106.661 5.9h-2.674V3.226c0-.892-.721-1.613-1.613-1.613s-1.613.721-1.613 1.613V5.9h-2.674c-.892 0-1.613.721-1.613 1.613s.721 1.613 1.613 1.613h2.674V11.8c0 .892.721 1.613 1.613 1.613s1.613-.721 1.613-1.613V9.126h2.674c.892 0 1.613-.72 1.613-1.613 0-.892-.721-1.613-1.613-1.613z",
            fill: "#D0EEFD"
          })
        }), (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M35.846 66.032c-4.324 0-8.447-1.85-11.321-5.075-2.872-3.22-4.232-7.546-3.734-11.87.621-5.376 4.199-10.049 9.336-12.193 2.335-.974 4.76-1.338 7.237-1.083a22.07 22.07 0 0120.624-14.078A22.066 22.066 0 0177.046 32.62a16.857 16.857 0 0120.06 13.087c2.584-.045 5.211.948 7.227 2.834a13.969 13.969 0 012.345 2.825c1.67 2.69 1.834 6.044.441 8.97-1.408 2.953-4.146 4.956-7.321 5.36l-.304-1.588-.154-1.606c2.133-.271 3.933-1.597 4.866-3.553.919-1.93.819-4.13-.268-5.88a10.784 10.784 0 00-1.807-2.172c-1.717-1.606-3.933-2.276-6.06-1.843a1.598 1.598 0 01-1.272-.28 1.607 1.607 0 01-.651-1.127A13.636 13.636 0 0080.565 35.47c-1.296 0-2.6.19-3.874.566-.74.22-1.534-.12-1.889-.808-3.267-6.334-9.71-10.268-16.814-10.268a18.86 18.86 0 00-18.013 13.134 1.602 1.602 0 01-1.845 1.089 11.563 11.563 0 00-6.761.69c-4 1.668-6.894 5.43-7.375 9.585-.398 3.46.646 6.783 2.94 9.354a11.939 11.939 0 008.904 3.995l29.23-.15h.009a1.613 1.613 0 01.008 3.226l-29.239.15z",
          fill: "#124099"
        }), (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M82.661 55.132c-5.12 0-9.287 4.167-9.287 9.286 0 5.12 4.166 9.287 9.287 9.287s9.286-4.166 9.286-9.287c0-5.12-4.165-9.286-9.286-9.286zm0 21.799c-6.898 0-12.513-5.613-12.513-12.513 0-6.899 5.615-12.511 12.513-12.511 6.899 0 12.512 5.613 12.512 12.51 0 6.9-5.613 12.514-12.512 12.514z",
          fill: "#124099"
        }), (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M79.771 68.922a1.611 1.611 0 01-1.14-2.753l5.78-5.781a1.614 1.614 0 012.281 2.282l-5.78 5.779a1.608 1.608 0 01-1.141.473z",
          fill: "#124099"
        }), (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M85.552 68.922c-.413 0-.826-.158-1.14-.473L78.63 62.67a1.613 1.613 0 112.28-2.282l5.781 5.78a1.611 1.611 0 01-1.14 2.754zM65.077 47.926a1.612 1.612 0 01-1.613-1.613v-3.237c0-.892.721-1.613 1.613-1.613s1.613.721 1.613 1.613v3.237c0 .89-.721 1.613-1.613 1.613zM52.128 47.926a1.612 1.612 0 01-1.613-1.613v-3.237c0-.892.721-1.613 1.613-1.613s1.613.721 1.613 1.613v3.237c0 .89-.721 1.613-1.613 1.613zM63.306 55.968c-.541 0-1.07-.273-1.375-.768-.371-.603-1.592-1.474-2.83-1.474-1.132 0-2.114.539-2.917 1.603-.54.708-1.55.849-2.26.312a1.613 1.613 0 01-.314-2.26c1.406-1.858 3.356-2.88 5.492-2.88 2.445 0 4.656 1.512 5.577 3.009a1.615 1.615 0 01-1.373 2.458z",
          fill: "#124099"
        })]
      }));

    default:
      return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
        viewBox: "0 0 110 100",
        fill: "none"
      }, props), {}, {
        children: [(0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M98.162 54.787a8.238 8.238 0 00-7.482-2.245c-.83-7.655-7.31-13.616-15.186-13.616-1.505 0-2.955.228-4.327.632-3.413-6.612-10.295-11.143-18.25-11.143-9.149 0-16.892 5.987-19.549 14.255-.84-.165-1.71-.255-2.6-.255-7.477 0-13.538 6.06-13.538 13.537 0 7.476 6.061 13.537 13.538 13.537l42.146-.218a10.824 10.824 0 01-1.152-4.853c0-6.02 4.879-10.898 10.9-10.898 6.018 0 10.897 4.879 10.897 10.898 0 1.697-.399 3.297-1.089 4.727 2.395-.108 4.797-.593 6.47-2.346 3.148-3.297 2.445-8.789-.778-12.012zM11.349 66.939H4.336a1.612 1.612 0 110-3.226h7.013c.892 0 1.612.72 1.612 1.613 0 .892-.72 1.613-1.612 1.613zM68.57 99.636h-7.012a1.612 1.612 0 110-3.226h7.012c.892 0 1.613.721 1.613 1.613s-.72 1.613-1.613 1.613z",
          fill: "#EDE6FF"
        }), (0, _jsxRuntime.jsx)("mask", {
          id: "error_svg__a",
          maskUnits: "userSpaceOnUse",
          x: 0,
          y: 69,
          width: 11,
          height: 4,
          children: (0, _jsxRuntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 69.161h10.237v3.226H0V69.16z",
            fill: "#fff"
          })
        }), (0, _jsxRuntime.jsx)("g", {
          mask: "url(#error_svg__a)",
          children: (0, _jsxRuntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.624 72.387H1.612a1.612 1.612 0 110-3.226h7.012c.892 0 1.613.721 1.613 1.613s-.721 1.613-1.613 1.613z",
            fill: "#EDE6FF"
          })
        }), (0, _jsxRuntime.jsx)("mask", {
          id: "error_svg__b",
          maskUnits: "userSpaceOnUse",
          x: 96,
          y: 1,
          width: 13,
          height: 13,
          children: (0, _jsxRuntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M96.474 1.614h11.8v11.798h-11.8V1.614z",
            fill: "#fff"
          })
        }), (0, _jsxRuntime.jsx)("g", {
          mask: "url(#error_svg__b)",
          children: (0, _jsxRuntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M106.661 5.9h-2.674V3.226c0-.892-.721-1.613-1.613-1.613s-1.613.721-1.613 1.613V5.9h-2.674c-.892 0-1.613.721-1.613 1.613s.721 1.613 1.613 1.613h2.674V11.8c0 .892.721 1.613 1.613 1.613s1.613-.721 1.613-1.613V9.126h2.674c.892 0 1.613-.72 1.613-1.613 0-.892-.721-1.613-1.613-1.613z",
            fill: "#EDE6FF"
          })
        }), (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M35.846 66.032c-4.324 0-8.447-1.85-11.321-5.075-2.872-3.22-4.232-7.546-3.734-11.87.621-5.376 4.199-10.049 9.336-12.193 2.335-.974 4.76-1.338 7.237-1.083a22.07 22.07 0 0120.624-14.078A22.066 22.066 0 0177.046 32.62a16.857 16.857 0 0120.06 13.087c2.584-.045 5.211.948 7.227 2.834a13.969 13.969 0 012.345 2.825c1.67 2.69 1.834 6.044.441 8.97-1.408 2.953-4.146 4.956-7.321 5.36l-.304-1.588-.154-1.606c2.133-.271 3.933-1.597 4.866-3.553.919-1.93.819-4.13-.268-5.88a10.784 10.784 0 00-1.807-2.172c-1.717-1.606-3.933-2.276-6.06-1.843a1.598 1.598 0 01-1.272-.28 1.607 1.607 0 01-.651-1.127A13.636 13.636 0 0080.565 35.47c-1.296 0-2.6.19-3.874.566-.74.22-1.534-.12-1.889-.808-3.267-6.334-9.71-10.268-16.814-10.268a18.86 18.86 0 00-18.013 13.134 1.602 1.602 0 01-1.845 1.089 11.563 11.563 0 00-6.761.69c-4 1.668-6.894 5.43-7.375 9.585-.398 3.46.646 6.783 2.94 9.354a11.939 11.939 0 008.904 3.995l29.23-.15h.009a1.613 1.613 0 01.008 3.226l-29.239.15z",
          fill: "#6542BE"
        }), (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M82.661 55.132c-5.12 0-9.287 4.167-9.287 9.286 0 5.12 4.166 9.287 9.287 9.287s9.286-4.166 9.286-9.287c0-5.12-4.165-9.286-9.286-9.286zm0 21.799c-6.898 0-12.513-5.613-12.513-12.513 0-6.899 5.615-12.511 12.513-12.511 6.899 0 12.512 5.613 12.512 12.51 0 6.9-5.613 12.514-12.512 12.514z",
          fill: "#6542BE"
        }), (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M79.771 68.922a1.611 1.611 0 01-1.14-2.753l5.78-5.781a1.614 1.614 0 012.281 2.282l-5.78 5.779a1.608 1.608 0 01-1.141.473z",
          fill: "#6542BE"
        }), (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M85.552 68.922c-.413 0-.826-.158-1.14-.473L78.63 62.67a1.613 1.613 0 112.28-2.282l5.781 5.78a1.611 1.611 0 01-1.14 2.754zM65.077 47.926a1.612 1.612 0 01-1.613-1.613v-3.237c0-.892.721-1.613 1.613-1.613s1.613.721 1.613 1.613v3.237c0 .89-.721 1.613-1.613 1.613zM52.128 47.926a1.612 1.612 0 01-1.613-1.613v-3.237c0-.892.721-1.613 1.613-1.613s1.613.721 1.613 1.613v3.237c0 .89-.721 1.613-1.613 1.613zM63.306 55.968c-.541 0-1.07-.273-1.375-.768-.371-.603-1.592-1.474-2.83-1.474-1.132 0-2.114.539-2.917 1.603-.54.708-1.55.849-2.26.312a1.613 1.613 0 01-.314-2.26c1.406-1.858 3.356-2.88 5.492-2.88 2.445 0 4.656 1.512 5.577 3.009a1.615 1.615 0 01-1.373 2.458z",
          fill: "#6542BE"
        })]
      }));
  }
};

var _default = SvgWarningUnsuccessful;
exports["default"] = _default;